module.exports = __webpack_public_path__ + "static/media/hatsun.dd8ba204.png";